// THIS FILE IS GENERATED BY 'npm run set-env-variables'

export const environment = {
  production: true,

  // Configuration/Feature-switches:
  envName: '',
  useServiceWorker: true,
  useOffers: true,
  useQandAs: true,
  useQandASearch: true,
  useRegionPerLocale: false,

  searchApi: '',
  searchApiKey: '',

  // Configuration of content
  appName: 'Helpful Information',
  appLogoUrl: 'https://rodekruis.github.io/510-ICON-LIBRARY/Beeldmerk_van_het_Nederlandse_Rode_Kruis.svg',
  mainPageHeader: 'Help for undocumented people',
  mainPageIntroduction: 'This site is by the Netherlands Red Cross for people who are undocumented: without residence permit or BSN.\n We do not share your personal details.\n \n Find information for local services like legal support, health, and shelter.\n Need help or do you have questions? Contact the WhatsApp helpdesk of the Red Cross: [+31 970 10 28 69 64](https://wa.me/3197010286964)\n \n',
  mainPageNotification: '<div class="d-flex"><img src="/assets/icons/contact_whatsapp.png" alt="" with=32 height=32 decoding=async loading=lazy> [**Red Cross WhatsApp Helpdesk**](https://wa.me/3197010286964)  <span>Monday-Sunday: `12:00`-`20:00`</span> </div>',
  errorHeader: 'Data Unavailable',
  errorMessage: 'Reach out to us at: ',
  errorContactUrl: 'https://www.rodekruis.nl/',
  errorRetry: 'Try again?',

  // Regions:
  regions: 'almere, amsterdam, den-haag, eindhoven, leeuwarden, lelystad, nijmegen, rotterdam, utrecht, , , , winter-shelters, policy-change-temporary-protection,',
  regionsLabels: 'Almere, Amsterdam, Den Haag, Eindhoven, Leeuwarden \n(Friesland), Lelystad, Nijmegen, Rotterdam, Utrecht, , , , Winter shelters in The Netherlands, Refugees from Ukraine: change in temporary protection,',
  regionsSheetIds: '1mod8O9EgvqpCN3ScyAKkOh34x3OGa-8yIc18K_t1xXU, 1OANMuGJxGBQ2ba3xVfKvTpD0EGQM-ukUrgRyN9tzMbQ, 1m43Tw7CWRUdPjaStq6dOi9yvHSYInP1lWjLetk1PrTI, 1OhMLlM6NFD7GkoQEYMP4lnI0FKd__PKdPvYw0x57l8k, 136iThtEhGoMMVFeuMJZdVSGDKFE6XyCcMWfHRhngGjI, 1ASaVCURxA7vLmc3Vp5NvoEkR58Mc53R35jTVp7GkxM0, 1lWUjA8_sqmY7JRmYOBWn3wfRk2whR-2soZ8qfn_Fdaw, 18qD1PGTK2jTExpVIXXWpjHdpe5KDy7IdcR537CusCLU, 1ZqizriL_RJ2dCcNVnCj0GM02pqOLWcIF18A4zVigsrU, , , , 1FMnlbHgoZJLuw5RPDNGRrGH-5tpB21kZOwa_Kidx8BI, 1kt34eFCCVWrC8RAezX9AzYZ0TiQqxGdcF4KCUkHciLY,',

  // Third-party tokens:
  // Google Sheets API:
  google_sheets_api_key: 'AIzaSyDCueUJ2O_xRYtfH3Gvy4ldM3jBwCk4UtY',
  google_sheets_api_url: 'https://sheets.googleapis.com/v4/spreadsheets',

  // Application Insights
  appInsightsConnectionString: 'InstrumentationKey=4ca91dae-7374-47cc-988a-7ce986d27ec0;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com',
};
